<template>
  <div>
    <div v-for="(notification, index) in listOfNotifications" :key="index">
      <Alert
        :title="notification.title"
        :message="notification.message"
        :variant="notification.type"
        class="mt-2 mb-2"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Ref, ref, watch, watchEffect } from "vue";

//Components
import Alert from "@/components/molecules/alert/BaseAlert.vue";

//Store
import { useStore } from "@/store/index.store";

//Types
import {
  NotificationWithID,
  NotificationWithTimeOut,
} from "@/types/notifications.type";
import { ActionTypes } from "@/store/modules/Notifications/action-types";

// Constant
const defaultShowTimer = 3000;
const store = useStore();

//State
const numberOfNotifications = ref(0);
const listOfNotifications = ref(store.getters.GetListOfNotifications);

watch(
  () => store.getters.GetListOfNotifications,
  () => (listOfNotifications.value = store.getters.GetListOfNotifications),
  { deep: true }
);

const arrayOfNotificationsWithDestructor: Ref<Array<NotificationWithTimeOut>> =
  ref([]);

//Functions to handle notifications list
const ReduceNumberOfNotification = () => (numberOfNotifications.value -= 1);

const SetNotificationDestructor = (lastNotification: NotificationWithID) => {
  const notificationWithDestructor = {
    ...lastNotification,
    destructor: setTimeout(() => {
      store.dispatch(ActionTypes.REMOVE_NOTIFICATION, lastNotification.id);
      arrayOfNotificationsWithDestructor.value =
        arrayOfNotificationsWithDestructor.value.filter(
          (n) => n.id != lastNotification.id
        );
    }, lastNotification.showTime || defaultShowTimer),
  };
  arrayOfNotificationsWithDestructor.value.push(notificationWithDestructor);
};

const GetLastNotification = (notifications: Array<NotificationWithID>) =>
  notifications[notifications.length - 1];

const AddNotification = (notifications: Array<NotificationWithID>) => {
  numberOfNotifications.value = notifications.length;

  const lastNotification: NotificationWithID =
    GetLastNotification(notifications);

  !lastNotification.permanent && SetNotificationDestructor(lastNotification);
};

const HandleNewArrayOfNotifications = (
  notifications: Array<NotificationWithID>
) => {
  numberOfNotifications.value < notifications.length
    ? AddNotification(notifications)
    : ReduceNumberOfNotification();
};

watchEffect(() => HandleNewArrayOfNotifications(listOfNotifications.value));
</script>
